<div class="main-creative-container" (click)="openDrawer()">
  <img [src]="creatives[0]" alt="Creative" class="main-creative" (error)="onImageError($event)"/>
</div>
@if(creativeCount > 1) {
    <div class="other-creatives-container">
        <div class="other-creative-item">
            <img [src]="creatives[1]" alt="Creative" class="other-creative" (error)="onImageError($event)" />
        </div>
        @if(creativeCount > 2) {
        <div class="other-creative-item">
            <img [src]="creatives[2]" alt="Creative" class="other-creative" (error)="onImageError($event)" />
        </div>
        }
        @if(creativeCount === 4) {
            <div class="other-creative-item">
                <img [src]="creatives[3]" alt="Creative" class="other-creative" (error)="onImageError($event)" />
            </div>
            }
        @if(creativeCount > 4) {
                <div class="other-creative-item">
                <span class="other-creative-count">{{ '+' + (creativeCount - 3) }}</span>
            </div>
        }
    </div>
}
